import Icon from '../components/Icon.vue'

Icon.register({
  heading: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 96v320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32v-128h-192v128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32v-320h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32v128h192v-128h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/heading.js
// module id = 1445
// module chunks = 0